import { useContext } from 'react'
import { QueryParamsContext } from 'src/contexts'

export const useQueryParamsState = () => {
  const [params] = useContext(QueryParamsContext)
  return params
}
